// extracted by mini-css-extract-plugin
export var MograPlayer = "player-module--MograPlayer--e7907";
export var buttonClose = "player-module--buttonClose--6ddb5";